// extracted by mini-css-extract-plugin
export var errorsContainer = "_sp-1";
export var link = "_sp-0";